document.addEventListener('DOMContentLoaded', function() {
    let modal_search = document.getElementById('modal_search');
    //Open/close modal search SECTION
    if (modal_search) {
        document.querySelectorAll('.search-icon').forEach(function (item) {
            item.addEventListener('click', function () {
                modal_search.classList.toggle('open');
            });
        });

        //Close modal search SECTION
        modal_search.addEventListener('click', function (e) {
            if (e.target === modal_search) {
                modal_search.classList.remove('open');
            }
        });
    }
});
